<template>
  <v-card v-if="computedTasks && computedTasks.length > 0">
    <v-card-text>
      <h3>
        <v-icon>alarm</v-icon
        ><router-link
          :to="{ name: 'tasks', query: { id: $keycloak.tokenParsed.entityid } }"
          >Tasks</router-link
        >
      </h3>
      <v-chip
        v-for="task in computedTasks"
        :key="task.id"
        color="orange"
        text-color="white"
        @click="navigate(task)"
      >
        {{ task.title ? task.title.body : "Loading" }}
      </v-chip>
    </v-card-text>
  </v-card>
</template>

<script>
import TASKS_DUE_CACHED from "@/graphql/directory/TasksDueCached";
import TASKS_UPDATED from "@/graphql/directory/TasksUpdated";
export default {
  name: "Tasks",
  apollo: {
    tasksDueCached: {
      query: TASKS_DUE_CACHED,
      subscribeToMore: {
        document: TASKS_UPDATED,
        updateQuery: (previousResult, { subscriptionData }) => {
          return {
            tasksDue: { ...subscriptionData.data.tasksUpdated }
          };
        }
      }
    }
  },
  computed: {
    computedTasks() {
      if (!this.tasksDueCached) {
        return undefined;
      }
      const tasks = this.tasksDueCached.filter((t) => {
        const mine = t.taskEntities
          .map((te) => te.entity.id)
          .includes(this.$keycloak.tokenParsed.entityid);
        return mine;
      });
      return tasks;
    }
  },
  methods: {
    navigate(task) {
      this.$router.push({ name: "task", params: { id: task.id } });
    }
  }
};
</script>